import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';

import CommonMultipleSearchSelectionWrapper from '../common/CommonMultipleSearchSelectionWrapper';
import { batchUpdateActions } from '../../behavior/batchUpdate';
import { Divider, Grid, Icon, Message } from 'semantic-ui-react';
import { inventoriesActions } from '../../behavior/inventories';
import { Loading, AccordionWrapper } from 'react-lib/dist/components-es';
import BatchUpdateFieldList from './BatchUpdateFieldList';
import ChangesNotificationModal from '../Inventory/InventoryDetails/ChangesNotificationModal';
import { fieldKey } from '../../constants';

const BatchUpdateFieldListContainer = ({
  actions,
  initialData,
  batchUpdatePossibleFieldsList,
  numberOfSelectedInventories,
  isLoading,
  formikProps,
  selectedFields,
  setSelectedFields,
  mode,
  setValidateOnChange,
  t
}) => {
  useEffect(() => {
    actions.getPossibleFieldsBatchUpdate();
    actions.getInitialData(false);
  }, []);

  const { submitForm, values } = formikProps;
  const mandatoryBatchUpdateFields = [fieldKey.GEN_CHECK_USER, fieldKey.GEN_CHECK_DATE];

  const onSelectedFieldsChange = value => {
    setSelectedFields(value);
  };
  

  return (
    batchUpdatePossibleFieldsList.length > 0 && (
      <AccordionWrapper
        titleClassName={'accordionHeaderCompact'}
        className="filterPanel"
        accordionTitle={'4. ' + t('inventory.batch.update.chose.fields')}
        closable={false}
        render={() => (
          <>
            <Loading isLoading={isLoading} />

            <Grid columns="equal">
              <Grid.Row stretched style={{ paddingBottom: '0px' }}>
                <Grid.Column>
                  <Message color={'yellow'}>
                    <Icon name="warning sign" />
                    {
                      <>
                        {t('inventory.batch.update.disclaimer.part1')}
                        <strong>{numberOfSelectedInventories}</strong>
                        {t('inventory.batch.update.disclaimer.part2')}
                      </>
                    }
                  </Message>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched style={{ paddingBottom: '0px' }}>
                <Grid.Column width={5}>
                  <div className="displayInlineBlock">
                    {t('inventory.batch.update.chose.fields.to.modify')}
                    <div
                      className="displayInlineBlock"
                      style={{ width: '250px', marginLeft: '10px' }}
                    >
                      <CommonMultipleSearchSelectionWrapper
                        optionsList={batchUpdatePossibleFieldsList.filter(
                          f => !mandatoryBatchUpdateFields.includes(f.value)
                        )}
                        onChange={value => onSelectedFieldsChange(value)}
                      />
                    </div>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Divider />
              <Grid.Row stretched style={{ paddingTop: '0', paddingBottom: '0' }}>
                <Grid.Column>
                  <Message color='yellow'>
                    <Icon name="warning sign" />
                    {t("inventory.batch.update.modifying.fields", {selectedFields: selectedFields.length, selectedInventories: numberOfSelectedInventories})}
                  </Message>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <BatchUpdateFieldList
                    props={formikProps}
                    initialData={initialData}
                    selectedFields={selectedFields}
                    mandatoryFields={batchUpdatePossibleFieldsList.filter(f =>
                      mandatoryBatchUpdateFields.includes(f.value)
                    )}
                    mode={mode}
                  />
                </Grid.Column>
              </Grid.Row>

              <Divider />
              <Grid.Row stretched style={{ marginBottom: '5px', paddingTop: '0px' }}>
                <Grid.Column>
                  <div>
                    <div style={{ float: 'left' }}>
                      {numberOfSelectedInventories > 0 && (
                        <ChangesNotificationModal
                          key="changesNotificationModal"
                          inventory={values}
                          mode={mode}
                          warning={t('save.modal.notification.batch.update.warning', {
                            numberOfInventories: numberOfSelectedInventories
                          })}
                          submitForm={() => {
                            setValidateOnChange(true);
                            submitForm();
                          }}
                        />
                      )}
                    </div>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </>
        )}
      />
    )
  );
};

BatchUpdateFieldListContainer.propTypes = {
  batchUpdatePossibleFieldsList: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
  ...state.inventories,
  batchUpdatePossibleFieldsList: state.batchUpdate.batchUpdatePossibleFieldsList
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getPossibleFieldsBatchUpdate: () => dispatch(batchUpdateActions.getPossibleFieldsBatchUpdate()),
    getInitialData: isCreateMode => dispatch(inventoriesActions.getInitialData(isCreateMode))
  }
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(BatchUpdateFieldListContainer);
